import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
var AlertPreformatted = function (_a) {
    var type = _a.type, message = _a.message, dismissible = _a.dismissible, onDismiss = _a.onDismiss;
    return (_jsxs("div", { className: "alert fade show alert-" + type + (dismissible ? " alert-dismissible" : ""), style: { "position": "fixed", "bottom": 0, "zIndex": 1000 }, role: "alert", children: [_jsx("pre", { children: message }), dismissible &&
                _jsx("button", { type: "button", className: "close", "data-dismiss": "alert", "aria-label": "Close", onClick: onDismiss, children: _jsx("span", { "aria-hidden": "true", children: "\u00D7" }) })] }));
};
export default AlertPreformatted;
